import { env } from "@/app/config/env";
import type { TelemetryBatch } from "./contracts";

/** Dedicated best-effort transport: a telemetry 401 never logs out the app or rejects a business action. */
export async function sendTelemetryBatch(
  batch: TelemetryBatch,
  token: string,
  tenantId: string,
  keepalive: boolean,
  signal: AbortSignal,
) {
  try {
    const response = await fetch(
      new URL("/api/telemetry/events", env.VITE_API_BASE_URL),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Tenant-Id": tenantId,
        },
        body: JSON.stringify(batch),
        keepalive,
        credentials: "omit",
        referrerPolicy: "no-referrer",
        signal: AbortSignal.any([signal, AbortSignal.timeout(5000)]),
      },
    );
    if (response.ok) return "accepted" as const;
    return response.status === 429 || response.status >= 500
      ? ("retry" as const)
      : ("discard" as const);
  } catch {
    return "retry" as const;
  }
}
